import { inject, Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { OltAuthServiceBase, OltConfigServiceBase } from '@outerlimitstech/ngx-app-core';
import { ISignalrMessage } from '../models/signalr-message';
import { BaseConfigService } from './base-config.service';

class CustomHttpClient extends signalR.DefaultHttpClient {
  token: string;
  tokenType: string;
  override send(request: signalR.HttpRequest): Promise<signalR.HttpResponse> {
    request.headers = {
      ...request.headers,
      Authorization: `${this.tokenType} ${this.token}`,
    };
    return super.send(request);
  }

  constructor(tokenType: string, token: string, logger: signalR.ILogger) {
    super(logger);
    this.token = token;
    this.tokenType = tokenType;
  }
}


@Injectable({
  providedIn: "root",
})
export class SignalrService {
  private connection!: signalR.HubConnection;
  messageBusMessage = new BehaviorSubject<ISignalrMessage | null>(null);

  private authService = inject(OltAuthServiceBase);
  private toastr = inject(ToastrService);
  private configService = inject(BaseConfigService);

  constructor() {
    this.initHub();
  }

  private initHub() {
    const token = this.authService?.token == null ? "" : this.authService.token;
    const tokenType = this.authService?.tokenType ?? "Bearer";
    const url = `${this.configService.signalRUrl}/broadcast`;

    const options: signalR.IHttpConnectionOptions = {
      httpClient: new CustomHttpClient(
        tokenType,
        token,
        signalR.NullLogger.instance
      ),
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
    };

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url, options)
      .configureLogging(signalR.LogLevel.Information)
      .withAutomaticReconnect()
      .build();

    this.configureClients();

    this.connection
      .start()
      .catch((error) => console.log(`SignalR connection error: ${error}`));
  }

  private configureClients(): void {
    this.connection.on("messagebus", (message: ISignalrMessage) => {
      console.log("hub.messagebus", message);
      this.messageBusMessage.next(message);
    });
  }

  public displayGrowlMessage(message: ISignalrMessage | null): void {
    if (message == null) {
      return;
    }

    const showAlert = message?.user?.username !== this.authService.username;
    if (showAlert === true && message?.alertMessage != null) {
      this.toastr.info(
        `- by ${message?.user?.fullName}`,
        message.alertMessage,
        { positionClass: "toast-top-right", closeButton: true }
      );
    }
  }
}
